module.exports = __webpack_public_path__ + "img/screen-anchor.b91d76c4.png";